<template>
  <main>
    <sqr-hero
      short="invoice_add"
      color="light"
      is-bold
      size="medium"
      :is-loading="adding"
    />
  </main>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import invoiceBlank from '../utils/invoiceBlank';

export default {
  name: 'InvoiceAdd',
  components: {},
  computed: {
    ...mapGetters('account', ['accountId', 'account']),
    ...mapGetters('invoice', ['invoice', 'loading', 'saving', 'error'])
  },
  data() {
    return {
      adding: false
    };
  },
  mounted() {
    this.invoiceAdd();
    this.$a().logEvent('invoice_add');
  },
  methods: {
    ...mapMutations('invoice', ['init', 'fieldSet', 'numberNew']),
    ...mapMutations('invoice', ['lineAdd', 'lineChange', 'lineRemove']),
    ...mapActions('invoice', ['save', 'validate', 'subscribe']),

    async invoiceAdd() {
      try {
        this.adding = true;
        const date = new Date().toISOString().substr(0, 10);
        const invoice = invoiceBlank(date);

        let account = this.account;
        if (account) {
          const issuers = account.issuers;
          if (issuers && Object.keys(issuers).length > 0) {
            const issuer =
              issuers[account.issuerId] || Object.values(issuers)[0];
            if (issuer) {
              invoice.issuerId = issuer.id;
              invoice.issuer = issuer;
            }
          }
          invoice.noProvider = account.noProvider;
          const providers = account.providers;
          if (
            !account.noProvider &&
            providers &&
            Object.keys(providers).length > 0
          ) {
            const provider =
              providers[account.providerId] || Object.values(providers)[0];
            if (provider) {
              invoice.providerId = provider.id;
              invoice.provider = provider;
            }
          }
        }
        const accountId = this.accountId;
        const result = await this.$db()
          .collection('accounts')
          .doc(accountId)
          .collection('invoices')
          .add(invoice);

        const id = result.id;

        await this.subscribe({ accountId, id });

        this.$router.replace({
          name: 'invoice-edit',
          params: { id }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.adding = false;
      }
    }
  }
};
</script>
